// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1W1S3","title":"Info_title__3TV33","selects":"Info_selects__2KG4K","requiredAsterisk":"Info_requiredAsterisk__3jXe2"};